import { useContext, useEffect, useMemo, useReducer, useState } from "react";
import { usePagination, useTable } from "react-table";
import { Get } from "../Rutas/ApiRest";
import "../index.css"
import { Contexto } from "../Context/Contexto";
import { GuiaBusquedaCont } from "../Context/BusquedaGuiaContext";
import { tokens } from "../Context/Tokens";
import { Carga } from "../Rutas/Servicios";
import { SinFactura, SinFacturaInicial } from "../Model/Tablas/SinFactura";
import SoloFacturas from "../Componentes/SoloFacturas";

function SinFacturaRastreo()
{
    const formatterDolar = new Intl.NumberFormat('en-US', {style: 'currency',
      currency: 'USD',
        minimumFractionDigits: 2
      })
      var count=0;
    const {tok}=useContext(tokens)
    const {Cli}=useContext(Contexto)
    

    const {GuiaBusqueda}=useContext(GuiaBusquedaCont)
    const datos=[
        SinFacturaInicial
      ]
      const columns=useMemo(() => SinFactura, [])
      const dato=useMemo(() => datos, [])
      const [data,Setdata]=useState(dato)    

     useEffect(()=>{
        ActualizarDatos();
     },[Cli.Eleccion])

     const ActualizarDatos=()=>
     {
        if(Cli.lCasilla[Cli.Eleccion].ecode!=undefined)
        {
            if(Cli.lCasilla[Cli.Eleccion].ecode!="")
            {
                const historialcargas=Get(Carga.SinFactura.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode).replace("@rut",Cli.rut).replace("@guiahija",GuiaBusqueda),"application/json",tok)
                historialcargas.then(resultado=>{Setdata(resultado)})
            }
        }

     }

          const {
            getTableProps, 
            getTableBodyProps, 
            headerGroups, 
            page,
            nextPage,
            previousPage,
            canNextPage,
            canPreviousPage,
            pageOptions,
            gotoPage,
            pageCount,
            state,
            prepareRow,
        } = useTable({
                // @ts-ignore
                columns,
                data,
            },
            usePagination
        );

        const { pageIndex } = state
    return (
        <>
        {data.length===0?<div><div className="alert au-alert-success alert-dismissible fade show au-alert au-alert--100per" role="alert" id="One"> <span className="content" >No tiene cargas sin facturas.</span>

                    </div></div>:<div className="row">
            <div className="col-12 py-2 py-sm-0">
              <div className="table-responsive" id="SinFactura">
              <div className="fondo-blanco h-100">
            {page.map((row: any) =>
            {
                count=count+1;
                prepareRow(row)
                return(
                    <div className="card-body">
                        <div className="accordion" id="accordionFlushTabla">
                        {row.cells.map((cell: any) =>
                        {
                            
                            return (
                                cell.column.Header==="No. de Guía"?
                                <>
                                 <SoloFacturas guia={cell.value} id={count} contenido={row.cells}></SoloFacturas>
                                </>:null
                            )
                        })}
                                   
                        </div>
                    </div>
                )
            })}
            

        </div>
              </div>
			  </div>
		  </div>

                    }

{data.length>10?<div className="table-pagination" style={{margin: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
<a href={"#Rastreo"}>
<button onClick={() => previousPage()} disabled={!canPreviousPage} className="btn btn-success">
                        Anterior
                    </button>
                   
                   
                </a>
                
                <span>
                    <strong style={{display: 'block', width: '100px', textAlign: 'center'}}>
                        {pageIndex + 1} / {pageOptions.length} 
                    </strong>
                </span>
                
                <a >
                <button onClick={() => nextPage()} disabled={!canNextPage} className="btn btn-success" >
                        Siguiente
                    </button>
                    
                   
                   
                </a>
                
            </div>:null}

        </>
    )
}

export default SinFacturaRastreo;